import { api } from '../../api';
import type { Onboarding } from '../../types';

// N39 — on the desk each setup form leads to the next (canon 11 E2 steps 3–5):
// Business profile → My trips → Availability → Today, where Finish is. Read from
// the API's own "what's left" (GET /v1/onboarding), never worked out here.

const STEP_PATH = { basics: '/profile', product: '/trips/new', availability: '/availability' } as const;

/** Where a setup step leads: the next one still to do, or Today for Finish. */
export function nextSetupStep(ob: Onboarding): string {
  // An account someone else set up opens on what was set up, on Today (§9).
  if (ob.missing.includes('review')) return '/today';
  const next = (['basics', 'product', 'availability'] as const).find((s) => !ob.steps[s]);
  return next ? STEP_PATH[next] : '/today';
}

/**
 * After a setup form saves: while the supplier is still setting up, the path of
 * the next step; once they are open for work, null — the form stays where it is.
 * A read that fails is null too: the save itself has already landed.
 */
export async function nextSetupPath(): Promise<string | null> {
  try {
    const ob = await api<Onboarding>('GET', '/onboarding');
    return ob.status === 'onboarding' ? nextSetupStep(ob) : null;
  } catch {
    return null;
  }
}
